module.exports = __webpack_public_path__ + "static/media/Icons_Public_Document_Centre_Forms.e06bc60b.png";